exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team_stats__desktopView--2Vg9U {\n  display: none;\n}\n\n.team_stats__statContainer--2rVEx {\n  margin: 0 5px 40px;\n}\n\n.team_stats__statBox--1VVKN {\n  padding: 20px 0;\n}\n\n.team_stats__statTitle--2gYrN {\n  padding-left: 5px;\n  font-weight: 500;\n  letter-spacing: 0.3px;\n}\n\n.team_stats__teamMenu--MwhUl {\n  padding-left: 10px;\n  border-bottom: 1px solid #3a3d40;\n}\n\n@media (min-width: 1024px) {\n  .team_stats__desktopView--2Vg9U {\n    display: block;\n  }\n  .team_stats__statBox--1VVKN {\n    padding: 20px 10px;\n  }\n  .team_stats__statTitle--2gYrN {\n    font-size: 20px;\n  }\n  .team_stats__teamMenu--MwhUl {\n    padding-left: 20px;\n  }\n}", ""]);

// exports
exports.locals = {
	"desktopView": "team_stats__desktopView--2Vg9U",
	"statContainer": "team_stats__statContainer--2rVEx",
	"statBox": "team_stats__statBox--1VVKN",
	"statTitle": "team_stats__statTitle--2gYrN",
	"teamMenu": "team_stats__teamMenu--MwhUl"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };